<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 mobile-layout">
      <md-card class="mobile-card">
        <md-card-header>
          <div class="md-title text-center">Найти мой дом</div>
        </md-card-header>
        <md-card-content>
          <filter-locality v-model="city"/>
          <filter-thoroughfare
            class="md-layout-item-field"
            v-model="street"
            :localityId="city ? city.id : null"
            :disabled="!city"
          />
          <filter-premises
            class="md-layout-item-field"
            v-model="apartment"
            :thoroughfareId="street ? street.id : null"
            :disabled="!street"
          />
        </md-card-content>
        <md-card-actions md-alignment="right">
          <md-button class="md-blue md-sm">
            Выбрать
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import {
  FilterLocality,
  FilterThoroughfare,
  FilterPremises
} from "@/components/Fillters";
export default {
  name: "SelectAddressPage",
  components: {
    FilterLocality,
    FilterThoroughfare,
    FilterPremises
  },
  data() {
    return {
      city: null,
      street: null,
      apartment: null
    };
  },
};
</script>

<style lang="scss" scoped>
.md-card-actions {
  border: 0 !important;
}
</style>
